import styled from 'styled-components';

const CheckboxOptions = styled.div`
  display:flex;
  flex: 1;
  padding: 10px 0px;
`;

export default CheckboxOptions;
